<template>
	<div class="group-item" :class="active ? 'active' : ''">
		<div class="group-avatar">
			<group-avatar 
				:groupId="group.id" 
				:groupName="group.showGroupName" 
				:defaultHeadImage="group.headImage"
				:defaultHeadName="groupDefaultHeadName"
				:size="42">
			</group-avatar>
		</div>
		<div class="group-name">
			<div>{{ group.showGroupName }}</div>
		</div>
	</div>
</template>

<script>
import GroupAvatar from '../common/GroupAvatar.vue';
import useUserStore from '../../store/userStore';

export default {
	name: "groupItem",
	components: {
		GroupAvatar
	},
	data() {
		return {
			userStore: useUserStore()
		}
	},
	props: {
		group: {
			type: Object
		},
		active: {
			type: Boolean
		}
	},
	computed: {
		groupDefaultHeadName() {
			const userInfo = this.userStore.userInfo || {};
			if (!this.group || !this.group.ownerId || this.group.ownerId == userInfo.id) {
				return userInfo.nickName || userInfo.userName || (this.group && this.group.showGroupName) || '';
			}
			return this.group.ownerName || this.group.ownerNickName || this.group.showGroupName;
		}
	}
}
</script>

<style lang="scss" scoped>
.group-item {
	height: 50px;
	display: flex;
	position: relative;
	padding: 5px 10px;
	align-items: center;
	white-space: nowrap;
	cursor: pointer;

	&:hover {
		background-color: #f7fafc; /* 更淡的灰色背景 */
	}

	&.active {
		background-color: #d4def5;
	}

	.group-name {
		padding-left: 10px;
		height: 100%;
		text-align: left;
		line-height: 50px;
		white-space: nowrap;
		overflow: hidden;
		font-size: var(--im-font-size);
	}
}
</style>
